<img src="/assets/files.svg">
<p>Przeciągnij w to pole mikroskopowe zdjęcie mleka, aby rozpocząć proces dodawania pliku</p>

<p><span class="line">-------------------------</span> lub <span class="line">-------------------------</span></p>
  <input hidden type="file" (change)="onFileSelected($event)" #fileInput>
<button mat-raised-button color="primary" (click)="fileInput.click()" [disabled]="!uploadAllowed|| disabled" *ngIf="sampleId">Dodaj plik</button>
<button mat-raised-button color="primary" (click)="openDialog()" [disabled]="!uploadAllowed|| disabled" *ngIf="!sampleId">Nowa próbka</button>
